import React, { useState } from 'react';
import 'twin.macro';
import { TitleRow } from '../text';
import { Button } from '../button';
import { Marker } from '../marker';
import { getRandomTopperFromPast } from 'services/dumpert';
import { gaEvent } from 'services/ga';

function getRandomNumberRange(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

export const TimeMachine = () => {
  const [isSpinning, setIsSpinning] = useState(false);
  const [randomYear, setRandomYear] = useState(null);

  const OLDEST_DUMPERT_YEAR = 2014;
  const SPIN_DURATION = 1500;
  const DURATION_AFTER_SPIN = 1000;

  const date = new Date();
  const dateString = new Date().toISOString().substring(0, 10);
  const thisYear = date.getFullYear();
  const thisMonth = dateString.substring(5, 7);
  const thisDay = dateString.substring(8, 10);

  async function handleClick() {
    setIsSpinning(true);
    const randomYear = getRandomNumberRange(OLDEST_DUMPERT_YEAR, thisYear);
    gaEvent('dmp_action', 'toppers_timemachine_click');

    try {
      const { data } = await getRandomTopperFromPast({
        year: randomYear,
        month: thisMonth,
        day: thisDay,
      });

      if (data?.items?.length) {
        const randomIndex = getRandomNumberRange(0, data.items.length);
        const randomItem = `/item/${data.items[randomIndex]?.id}`;

        setTimeout(() => {
          setIsSpinning(false);
          setRandomYear(randomYear);

          setTimeout(() => {
            if (randomItem) {
              window.open(randomItem);
              setRandomYear(null);
            }
          }, DURATION_AFTER_SPIN);
        }, SPIN_DURATION);
      } else {
        setIsSpinning(false);
      }
    } catch (error) {
      setIsSpinning(false);
    }
  }
  return (
    <div tw='my-6'>
      <div tw='relative'>
        <Marker label='Nieuw' tw='absolute -top-1 left-0' />
        <TitleRow tw='mb-1' text='Toppers tijdmachine' />
      </div>
      <div tw='bg-secondary rounded-lg p-4 flex flex-col'>
        <div tw='h-16 overflow-hidden relative border-2 border-gray-600 rounded-lg'>
          {/* Mask for slot machine effect */}
          <div tw='absolute inset-0 bg-gradient-to-b from-black via-transparent to-black z-10' />

          {isSpinning ? (
            <div tw='text-4xl font-bold animate-[slotMachine_0.5s_linear_infinite] text-center font-mono text-white'>
              {Array.from({ length: 10 }, (_, i) => (
                <div key={i} tw='py-2'>
                  {getRandomNumberRange(OLDEST_DUMPERT_YEAR, thisYear)}
                </div>
              ))}
            </div>
          ) : randomYear ? (
            <div tw='text-4xl font-bold text-center py-2 font-mono text-white'>{randomYear}</div>
          ) : null}
        </div>
        <div tw='flex justify-center mt-4'>
          <Button
            primary
            label='Klik om een topper te zien'
            onClick={handleClick}
            disabled={isSpinning || randomYear}
          />
        </div>
      </div>
    </div>
  );
};
